import { Route, Routes } from "react-router-dom";
import { Space } from "~/lib/types";
import { SpaceOrWorkspaceScope, SpaceScope } from "~/hooks/useScope";
import { CriticalExposuresPage } from "~/pages/space/home-dashboard/critical-exposures/CriticalExposuresPage";
import { SpaceDashboardPage } from "~/pages/space/SpaceDashboardPage/SpaceDashboardPage";
import { SlasDashboardPage } from "~/pages/space/SlaDashboardPage/SlasDashboardPage";
import { InitiativeDetailPage } from "~/pages/space/home-dashboard/TopActionsCard/components/InitiativeDetailPage/InitiativeDetailPage";
import { InitiativeRemediationsTab } from "~/pages/space/home-dashboard/TopActionsCard/components/InitiativeDetailPage/InitiativeRemediationsTab/InitiativeRemediationsTab";
import { InitiativeAssetsTab } from "~/pages/space/home-dashboard/TopActionsCard/components/InitiativeDetailPage/InitiativeAssetsTab/InitiativeAssetsTab";
import { InitiativeFindingsTab } from "~/pages/space/home-dashboard/TopActionsCard/components/InitiativeDetailPage/InitiativeFindigsTab/InitiativeFindingsTab";

type DashboardRoutesProps = {
  space: Space;
  scope: SpaceOrWorkspaceScope;
};

export function DashboardRoutes({ space, scope }: DashboardRoutesProps) {
  return (
    <Routes>
      <Route
        index
        element={<SpaceDashboardPage space={space} scope={scope} />}
      />
      <Route
        path="critical-exposures"
        element={<CriticalExposuresPage space={space} scope={scope} />}
      />
      <Route
        path="slas"
        element={<SlasDashboardPage space={space} scope={scope} />}
      />
      <Route
        path="initiatives/:initiativeMrn"
        element={
          <InitiativeDetailPage
            scope={scope}
            spaceScope={space as SpaceScope}
          />
        }
      >
        <Route index element={<InitiativeRemediationsTab />} />
        <Route path="remediations" element={<InitiativeRemediationsTab />} />
        <Route path="findings" element={<InitiativeFindingsTab />} />
        <Route path="assets" element={<InitiativeAssetsTab />} />
      </Route>
    </Routes>
  );
}
